import axios from 'axios'
import { SV_SOJ_ORCMOCK_ADDRESS } from '../../constants';

const _ = require('lodash')
const headers = {'Content-Type': 'application/json'}

export function getFlyFacetDataDefaultFromServer(rqValues){
    console.log('%%%%%%%%%%%%%%%sv++++REST API For favHotelsNow from Microservices DB swith sae key :' + rqValues)
    return dispatch => {
        dispatch(getFacetFlightsBegin())

        const url = `${SV_SOJ_ORCMOCK_ADDRESS}/essearch/facetFilterhotels`
        //const url = 'http://localhost:8080/essearch/facetFilterhotels'
      
          
        axios.post(url, rqValues, {headers:headers})
        .then(
            r => {
                if(r.data.facetData){
                   
                    const comData = r.data.facetData
                   
                   
                    let newfacetData = { facetData : comData}
                    dispatch(getFacetFlightsSuccess(newfacetData))
                }
                else {
                    const comData = { items: []}
                    dispatch(getFacetFlightsSuccess(comData))
                }
            }
        ).catch(
            e=>dispatch(getFacetFlightsError(e))
        )
    }

}

export const getFacetFlightsBegin = () => dispatch => {
    dispatch({
        type:"facet/FLIGHTS_BEGIN"
        
    })
}

export const getFacetFlightsSuccess = (data) => dispatch => {
   
     dispatch({
        type: "facet/FLIGHTS_SUCCESS",
        payload: data
    })

   
}



export const getFacetFlightsError = (e) =>dispatch => {
    dispatch({
        type:"facet/FLIGHTS_ERROR",
        error:e
    })
}

export const saveFlyFacetFilterCheckSuccess = (data) => dispatch => {
    console.log('sv*********saveFlyFacetFilterCheckSuccess  start')
    console.log(data)
    console.log('sv*********saveFlyFacetFilterCheckSuccess  end')
    let comData = {
       

        //svfb end
        

        "minBudgetPrice":20,
        "maxBudgetPrice":800,
        "valueSlider":100,
        
        "checkedAirline1Label":"Delta Airlines",
        "checkedAirline1":true,
        "disabledAirline1":false,

        "checkedAirline2Label":"Alaska Airlines",
        "checkedAirline2":true,
        "disabledAirline2":false,

        checkedAirline3Label:'American Airlines',
        checkedAirline3:true,
        disabledAirline3:false,

        checkedAirline4Label:'Frontier Airlines',
        checkedAirline4:true,
        disabledAirline4:false,

        checkedAirline5Label:'Spirit Airlines',
        checkedAirline5:true,
        disabledAirline5:false,

        checkedAirline7Label:'AS Airlines',
        checkedAirline7:true,
        disabledAirline7:false,

        checkedAirline8Label:'SY Airlines',
        checkedAirline8:true,
        disabledAirline8:false,

        checkedSeat0Label:'Carry On Baggage',
        checkedSeat0:true,
        disabledSeat0:false,

        checkedSeat1Label:'Seat Selection',
        checkedSeat1:true,
        disabledSeat1:false,

        checkedTake0Label:'Early Morning',
        checkedTake0:true,
        disabledTake0:false,

        checkedTake1Label:'Morning',
        checkedTake1:true,
        disabledTake1:false,

        checkedTake2Label:'Afternoon',
        checkedTake2:true,
        disabledTake2:false,

        checkedTake3Label:'Evening',
        checkedTake3:true,
        disabledTake3:false,


        checkedLand0Label:'Early Morning',
        checkedLand0:true,
        disabledLand0:false,

        checkedLand1Label:'Morning',
        checkedLand1:true,
        disabledLand1:false,

        checkedLand2Label:'Afternoon',
        checkedLand2:true,
        disabledLand2:false,

        checkedLand3Label:'Evening',
        checkedLand3:true,
        disabledLand3:false,
        
        checkedStop0Label:'Non Stop',
        checkedStop0:true,
        disabledStop0:false,
        
        checkedStop1Label:'1 or More Stops',
        checkedStop1:true,
        disabledStop1:false,

        checkedAirline6Label:'United Airlines',
        checkedAirline6:true,
        disabledAirline6:false

        

      
    }
    let newfacetData = { facetData : data.facetData, svflyfacet_myloc:data.svflyfacet_myloc}
    dispatch(getFacetFlightsSuccess(newfacetData))
/*
    dispatch({
        type: "facet/FLIGHTS_SUCCESS",
        payload: data
    })
    */
}